<template>
  <div>
    <div class="title">
      <p class="name">发票管理<span class="back" @click="back()" v-if="isApp !== 2">返回<i class="backIcon">></i></span></p>
    </div>
    <div class="bill-center-top" :style="{ height: tabHeight > 65 ? '40px' : '20px' }">
      <div class="bill-center-row bill-center-bg ">
        <span class="bill-center-txt">发票类型</span>
      </div>
      <div class="line2"></div>
      <div class="bill-center-row bill-center-bg">
        <van-radio-group class="bill-radio-txt" v-model="billRadio" direction="horizontal">
          <!--<van-radio checked-color="#C41335" name="1" icon-size="18px">普通发票</van-radio>&nbsp;&nbsp;&nbsp;&nbsp;-->
          <van-radio checked-color="#C41335" name="2" icon-size="18px">增值税专用发票</van-radio>
        </van-radio-group>
      </div>
      <div class="line3"></div>
      <!-- TODO 个人发票 -->
      <div class="bill-center-bg" v-show="this.billRadio === '1'">
        <div class="bill-center-row bill-center-bg">
          <span class="bill-center-txt">发票抬头</span>
        </div>
        <div class="line2"></div>
        <div class="bill-center-row bill-center-bg">
          <van-radio-group class="bill-radio-txt" v-model="otherRadio" direction="horizontal" @change="otherRadioChange">
            <van-radio checked-color="#C41335" name="1" icon-size="18px">个人</van-radio>&nbsp;&nbsp;&nbsp;&nbsp;
            <van-radio checked-color="#C41335" name="2" icon-size="18px">企业</van-radio>
          </van-radio-group>
        </div>
        <div class="line"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">抬头</span>
          <input id="rise_input" v-model="presenterRise" class="flex" type="text" placeholder="请输入开票抬头" maxlength="50" />
        </div>
        <div class="line2" v-show="otherRadio === '2'"></div>
        <div class="bill-center-row flex-row ct" v-show="otherRadio === '2'">
          <span class="bill-center-txt2 bill-center-txt2-width">税号</span>
          <input v-model="taxNumber" class="flex" type="text" placeholder="请输入公司税号" maxlength="20" />
        </div>
      </div>
      <!-- TODO 个人发票 -->
      <!-- TODO 增值税专用发票 -->
      <div id="bill_center_zzsfp" class="bill-center-bg" v-show="this.billRadio === '2'">
        <div class="bill-center-row">
          <span class="bill-center-txt">增票资质信息</span>
        </div>
        <div class="line"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">单位名称</span>
          <input v-model="companyName" class="flex" type="text" placeholder="发票抬头需与签署合同中抬头一致" maxlength="50" />
        </div>
        <div class="line2"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">纳税人识别号</span>
          <input v-model="companyNo" class="flex" type="text" placeholder="纳税人识别号" maxlength="20" />
        </div>
        <div class="line"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">注册地址</span>
          <input v-model="companyAddress" class="flex" type="text" placeholder="请输入注册地址" maxlength="50" />
        </div>
        <div class="line"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">注册电话</span>
          <input v-model="companyPhone" class="flex" type="text" placeholder="请输入注册电话" maxlength="13" />
        </div>
        <div class="line"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">开户银行</span>
          <input v-model="companyBank" class="flex" type="text" placeholder="请输入开户银行名称" maxlength="20" />
        </div>
        <div class="line"></div>
        <div class="bill-center-row flex-row ct">
          <span class="bill-center-txt2 bill-center-txt2-width">银行账户</span>
          <input v-model="companyBankNo" class="flex" type="text" placeholder="请输入开户银行账户" maxlength="25" />
        </div>
      </div>
      <!-- TODO 增值税专用发票 -->
      <div class="line3"></div>
      <div class="bill-center-row bill-center-bg">
        <span class="bill-center-txt">收票人信息</span>
      </div>
      <div class="line2"></div>
      <div class="bill-center-address-layout bill-center-bg">
        <div class="bill-center-address-list-layout" id="bill_center_list_layout">
          <!-- TODO 根据AddressList的size去动态绑定当前div的宽度，实现横向滚动，其中190为item的宽度，10为margin-right -->
          <div v-bind:style="{ width: (billAddressList.length * 250 + billAddressList.length * 10 + 12) + 'px' }">
            <div v-for="(item, index) in billAddressList" :key="index" class="bill-center-address-item"
              v-bind:class="[addressSelectIndex === index ? 'bill-center-address-item-select' : 'bill-center-address-item-unselect']">
              <div v-on:click="addressItemClick(item, index)">
                <div class="bill-center-address-item-title bill-center-address-item-txt1">{{ item.name }}</div>
                <div class="line2"></div>
                <div class="bill-center-address-item-txt m-top">{{ item.phone }}</div>
                <div class="bill-center-address-item-txt m-top bill-center-address-item-txt1">
                  {{ item.province }}&nbsp;&nbsp;{{ item.city }}&nbsp;&nbsp;{{ item.area }}</div>
                <div class="bill-center-address-item-txt bill-center-address-item-txt2">{{ item.address }}</div>
              </div>
              <div class="flex-row ct bill-center-address-item-edit-layout">
                <span v-on:click="delAddress(item, index)">删除</span>
                <div class="line4"></div>
                <span v-on:click="editAddress(item, index)">修改</span>
                <div class="line4" v-show="item.is_default !== 1"></div>
                <span v-on:click="setDefaultAddress(item, index)" v-show="item.is_default !== 1">设为默认地址</span>
                <div class="flex"></div>
              </div>
              <div class="bill-center-address-item-default" v-show="item.is_default === 1">默认地址</div>
              <img src="../images/icon-select.png" v-show="addressSelectIndex === index">
            </div>
          </div>
        </div>
        <div class="flex-row ct bill-center-address-add-layout" v-on:click="addAddress">+ 新增收货地址</div>
      </div>
      <div style="width: 100%;height: 90px;background: #f2f2f2;"></div>
      <div class="bill-center-bottom-layout" :style="{ bottom: tabHeight + 'px' }"
        v-bind:class="[showBtnLayout ? 'bill-center-bottom-layout-block' : 'bill-center-bottom-layout-none']">
        <button id="bill_center_btn" v-on:click="submitData" v-bind:style="{ backgroundColor: btnBg }">确认提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { Toast } from 'mint-ui'
import wxshare from '../../../wx/weixin'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      tabHeight: 0,
      billCenterType: 0, // 0表示从个人中心跳转；1表示从订单跳转
      orderNo: '', // 订单编号
      btnBg: '#FECDCD',
      billRadio: '2', // 1：普通发票；2: 增值税票
      otherRadio: '1', // 1：个人；2: 企业
      presenterRise: '', // 抬头
      taxNumber: '', // 税号
      companyName: '', // 公司名称
      companyNo: '', // 纳税人识别号
      companyAddress: '', // 注册地址
      companyPhone: '', // 注册电话
      companyBank: '', // 开户银行
      companyBankNo: '', // 银行帐号
      addressSelectIndex: 0, // 当前选中的地址信息
      billCenterBean: {}, // 发票实体类
      billAddressList: [], // 地址列表数据
      billAddressWidth: 0, // 地址列表横向的宽度
      docmHeight: 0,
      showHeight: 0,
      showBtnLayout: true, // 输入法弹出需要将底部按钮隐藏
      isApp: 0
    }
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    otherRadioChange: function (state) {
      // 个人，公司切换事件
      const riseInput = document.getElementById('rise_input')
      if (state === '1') {
        riseInput.setAttribute('placeholder', '请输入开票抬头')
      } else {
        riseInput.setAttribute('placeholder', '与签署合同中企业抬头统一')
      }
    },
    getBillData: function () {
      // 获取发票数据
      this.utils.GET(this.companyUrl + '/invoice/getInfo', (resultData) => {
        if (resultData.success) {
          this.billCenterBean = resultData.data
          if (
            this.billCenterBean === null ||
            this.billCenterBean === undefined
          ) {
            // 首次进入，无开票信息
            console.log('首次进入，无开票信息，需要新增发票')
          } else {
            this.setBillData()
            if (this.billCenterType === 1) {
              Dialog.alert({
                title: '温馨提示',
                message:
                  '发票抬头（单位/个人）与合同抬头（甲方）需保持一致，一经确认，系统无法修改'
              }).then(() => {
                console.log('close')
              })
            }
          }
        }
      })
    },
    setBillData: function () {
      // 设置发票信息
      this.otherRadioChange(this.billCenterBean.rise_type + '')
      if (this.billCenterBean.invoice_type === 1) {
        // 普票
        this.billRadio = '1'
        this.presenterRise = this.billCenterBean.invoice_rise // 抬头
        if (this.billCenterBean.rise_type === 1) {
          // 个人
          this.otherRadio = '1'
        } else {
          // 企业
          this.otherRadio = '2'
          this.taxNumber = this.billCenterBean.tax_num // 税号
        }
      } else {
        // 增票
        this.billRadio = '2'
        this.companyName = this.billCenterBean.invoice_rise // 抬头
        this.companyNo = this.billCenterBean.tax_num // 税号
        this.companyBank = this.billCenterBean.bank // 开户银行
        this.companyBankNo = this.billCenterBean.account // 开户账号、银行账户
        this.companyAddress = this.billCenterBean.registe_address // 注册地址
        this.companyPhone = this.billCenterBean.registe_phone // 注册手机
      }
      // TODO 商城全部都是曾票
      this.billRadio = '2'
    },
    getAddressListData: function () {
      // 获取地址列表数据
      const that = this
      this.utils.GET(this.accountUrl + '/site/list', (resultData) => {
        if (
          resultData.success &&
          resultData.data !== null &&
          resultData !== undefined
        ) {
          that.billAddressList = resultData.data
          if (that.billAddressList.length <= 0) {
            document.getElementById('bill_center_list_layout').style.display =
              'none'
          } else {
            document.getElementById('bill_center_list_layout').style.display =
              'block'
          }
        } else {
          // 容错处理
          that.addressSelectIndex = -1
          document.getElementById('bill_center_list_layout').style.display =
            'none'
        }
        this.checkDefaultAddressInList()
      })
    },
    checkDefaultAddressInList: function () {
      // 检查是否有默认地址
      if (this.billAddressList !== null && this.billAddressList !== undefined) {
        // TODO 理论上来说billAddressList有值那么默认地址都是第一个，不需要进行判断，防止万一，还是这样操作一下吧
        this.billAddressList.every((item, index) => {
          if (item.is_default === 1) {
            this.addressSelectIndex = index
            console.log('存在默认地址，跳出循环。。。')
            return false
          } else {
            this.addressSelectIndex = 0
            return true
          }
        })
      } else {
        this.addressSelectIndex = -1
      }
    },
    addAddress: function () {
      // 新增地址
      this.$router.push({
        path: '/editAddress',
        query: {
          editAddressType: 0
        }
      })
    },
    delAddress: function (item, index) {
      // 删除地址
      const that = this
      const param = {
        id: item.id
      }
      this.utils.POST(this.accountUrl + '/site/delete', param, (resultData) => {
        // 删除地址
        if (resultData.success) {
          that.billAddressList.splice(index, 1)
          if (that.billAddressList.length <= 0) {
            document.getElementById('bill_center_list_layout').style.display =
              'none'
            that.addressSelectIndex = -1
          }
          Toast('删除成功')
          if (that.addressSelectIndex === index) {
            that.addressSelectIndex = 0
          }
        }
      })
    },
    editAddress: function (item, index) {
      // 修改地址
      this.$router.push({
        path: '/editAddress',
        query: {
          editAddressType: 1,
          editAddressBean: item
        }
      })
    },
    setDefaultAddress: function (item, index) {
      // 设置默认地址
      if (item.is_default === 1) {
        Toast('当前地址已是默认地址')
        return
      }
      // let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      // userinfo.tails.userinfo[0].id
      const param = {
        id: item.id,
        phone: item.phone,
        name: item.name,
        user_id: item.user_id,
        zip_code: item.zip_code,
        province: item.province,
        city: item.city,
        area: item.area,
        address: item.address,
        is_default: 1
      }
      this.utils.POST(this.accountUrl + '/site/update', param, (resultData) => {
        if (resultData.success) {
          Toast('设置成功')
          this.getAddressListData()
        }
      })
    },
    addressItemClick: function (item, index) {
      // 地址列表Item点击事件
      this.addressSelectIndex = index
    },
    submitData: function () {
      // 提交数据
      if (!this.checkData(true)) return
      // 获取当前选取的地址信息
      if (this.billAddressList.length < 1) {
        Toast('请填写收货地址')
        return false
      }
      const personBean = this.billAddressList[this.addressSelectIndex]
      const param = {
        invoice_type: this.billRadio, // 1普票、2增票
        rise_type: this.otherRadio, // 1个人、2企业
        reciver_name: personBean.name, // 收件人姓名
        reciver_phone: personBean.phone, // 收件人手机号
        reciver_address: personBean.address, // 收件地址
        province: personBean.province, // 省
        city: personBean.city, // 市
        area: personBean.area // 区
      }
      if (this.billRadio === '1') {
        // 普通发票
        param.invoice_rise = this.presenterRise // 抬头
        if (this.otherRadio === '2') {
          // 公司
          param.tax_num = this.taxNumber // 税号
        }
      } else {
        // 增值税票
        param.invoice_rise = this.companyName // 抬头
        param.tax_num = this.companyNo // 税号
        param.bank = this.companyBank // 开户账号、银行账户
        param.account = this.companyBankNo // 开户银行
        param.registe_phone = this.companyPhone // 注册手机
        param.registe_address = this.companyAddress // 注册地址
      }
      if (this.billCenterType === 1) {
        // 订单过来，直接开票
        param.id = this.orderNo // 订单编号
        this.utils.POST(this.companyUrl + '/invoice/save', param, (result) => {
          if (result.success) {
            this.showSuccessDialog()
          }
        })
      } else {
        // 新增发票
        if (
          this.billCenterBean === null ||
          this.billCenterBean === undefined ||
          this.billCenterBean.id <= 0
        ) {
          this.utils.POST(
            this.companyUrl + '/invoice/addInfo',
            param,
            (result) => {
              if (result.success) {
                Toast('操作成功')
                // this.getBillData() // 重新请求数据
              }
            }
          )
        } else {
          // 编辑发票信息
          param.id = this.billCenterBean.id // 发票ID
          this.utils.POST(
            this.companyUrl + '/invoice/editInfo',
            param,
            (result) => {
              if (result.success) {
                Toast('操作成功')
              }
            }
          )
        }
      }
    },
    showSuccessDialog: function () {
      // 显示成功弹窗
      Dialog.alert({
        title: '提交成功',
        message:
          '我们会尽快给您邮寄发票请您耐心等待！\n如有问题咨询客服热线:\n400-1919-119'
      }).then(() => {
        this.$router.back(-1)
      })
    },
    checkData: function (showToast) {
      // 检查数据是否正确
      // const regex = '^[\u4E00-\u9FA50-9a-zA-Z_!@#$&*+=.|,:()\\"\\\'\\n，。！、：（）“”《》？]+$'
      const regex = '^[\u4E00-\u9FA50-9a-zA-Z()_s（）——]+$'
      const taxRegex = '^[0-9a-zA-Z]+$'
      if (this.billRadio === '1') {
        // 个人
        if (this.presenterRise.length <= 0) {
          if (showToast) Toast('请输入开票抬头')
          return false
        }
        if (!this.presenterRise.match(regex)) {
          if (showToast) Toast('开票抬头只能输入中文、英文、数字')
          return false
        }
        if (this.otherRadio === '2') {
          // 公司
          if (this.taxNumber.length <= 0) {
            if (showToast) Toast('请输入公司税号')
            return false
          }
          if (!this.taxNumber.match(taxRegex)) {
            if (showToast) Toast('公司税号输入有误')
            return false
          }
        }
      } else {
        // 增值税票
        if (this.companyName.length <= 0) {
          if (showToast) Toast('请输入单位名称')
          return false
        }
        if (!this.companyName.match(regex)) {
          if (showToast) Toast('单位名称只能输入中文、英文、数字')
          return false
        }
        if (this.companyNo.length <= 0) {
          if (showToast) Toast('请输入纳税人识别号')
          return false
        }
        if (!this.companyNo.match(taxRegex)) {
          if (showToast) Toast('纳税人识别号输入有误')
          return false
        }
        if (this.companyAddress.length <= 0) {
          if (showToast) Toast('请输入注册地址')
          return false
        }
        if (!this.companyAddress.match(regex)) {
          if (showToast) Toast('注册地址只能输入中文、英文、数字')
          return false
        }
        if (this.companyPhone.length <= 0) {
          if (showToast) Toast('请输入注册电话')
          return false
        }
        if (this.companyPhone.length < 10) {
          // 0746-2389122
          if (showToast) Toast('注册电话输入有误')
          return false
        }
        if (this.companyBank.length <= 0) {
          if (showToast) Toast('请输入开户银行')
          return false
        }
        if (!this.companyBank.match(regex)) {
          if (showToast) Toast('开户银行只能输入中文、英文、数字')
          return false
        }
        const bankRegex = '^[0-9]+$'
        if (this.companyBankNo.length <= 0) {
          if (showToast) Toast('请输入开户银行账户')
          return false
        }
        if (!this.companyBankNo.match(bankRegex)) {
          if (showToast) Toast('开户银行账户输入有误')
          return false
        }
      }
      if (this.addressSelectIndex < 0) {
        if (showToast) Toast('请选择收获地址')
        return false
      }
      return true
    },
    androidTabHeight: function (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 5
        }
      } else {
        this.tabHeight =
          value !== 'null' ? this.tabHeight + parseInt(value) : 0
      }
    }
  },
  mounted () {
    wxshare.wxShareHomePage(
      '【中消在线】消防安全产品一站式采购平台',
      '品质保障，正品低价，支持线上交易',
      'http://cdn.zxzx119.com/1294196519632633856'
    )
    this.billCenterType = parseInt(this.$route.query.billCenterType)
    if (this.billCenterType === undefined) {
      this.billCenterType = 0
    }
    if (this.billCenterType === 1) {
      this.orderNo = this.$route.query.orderNo
    }
    console.log(
      'billCenterType ---> ' +
      this.billCenterType +
      ' orderNo ---> ' +
      this.orderNo
    )
    this.getBillData()
    this.getAddressListData()
    // 立马获取初始值
    this.docmHeight = window.innerHeight
    window.onresize = () => {
      // window.onresize监听页面高度的变化
      return (() => {
        this.showHeight = window.innerHeight
      })()
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0
    if (this.$route.query.isApp) {
      this.isApp = parseInt(this.$route.query.isApp)
      localStorage.setItem('isApp', this.isApp)
      if (this.isApp === 2) {
        this.utils.GET(this.companyUrl + '/ent/json', function (res) {
          localStorage.setItem('userinfo', JSON.stringify(res.data))
        })
      }
    } else if (localStorage.getItem('isApp')) {
      this.isApp = parseInt(localStorage.getItem('isApp'))
    }
    if (
      parseInt(this.$route.query.isApp) === 1 ||
      parseInt(localStorage.getItem('isApp')) === 1 ||
      parseInt(this.$route.query.isApp) === 2 ||
      parseInt(localStorage.getItem('isApp')) === 2
    ) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  },
  computed: {
    // 计算当前输入是否正确
    isAllOk: function () {
      return this.checkData(false)
    }
  },
  watch: {
    // 通过监听去改变按钮的颜色
    isAllOk: function (val) {
      if (val) {
        this.btnBg = '#C41335'
      } else {
        this.btnBg = '#FECDCD'
      }
    },
    showHeight: function () {
      let height = this.docmHeight * 0.2
      let onheight = this.docmHeight - this.showHeight
      this.showBtnLayout = onheight < height
    }
  }
}
</script>

<style scoped>
.title {
  height: 50px;
  line-height: 50px;
  width: 100%;
  padding: 0 13px 0 13px;
  background: #ffffff;
  position: fixed;
  top: 0;
  z-index: 2;
  border-bottom-style: solid;
  border-bottom-color: #f2f2f2;
  border-bottom-width: 1px;
}

.name {
  font-size: 15px;
  color: #000000;
  font-weight: bold;
}

.back {
  float: right;
  font-size: 13px;
  color: #999999;
}

.backIcon {
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  font-size: 13px;
  color: #999999;
}

body {
  background: #f2f2f2;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.ct {
  align-items: center;
  justify-content: center;
}

.flex {
  flex: 1;
}

.m-top {
  margin-top: 5px;
}

.line {
  width: calc(100% - 13px);
  height: 1px;
  position: relative;
  margin-left: 13px;
  background: #f2f2f2;
}

.line2 {
  width: 100%;
  height: 1px;
  background: #f2f2f2;
}

.line3 {
  width: 100%;
  height: 15px;
  background: #f2f2f2;
}

.line4 {
  width: 1px;
  height: 12px;
  background: #d3d1d4;
}

::-webkit-input-placeholder {
  /* 修改input placeholder文字颜色 */
  color: #bebebe;
}

:-moz-placeholder {
  /* 修改input placeholder文字颜色 */
  color: #bebebe;
}

:-ms-input-placeholder {
  /* 修改input placeholder文字颜色 */
  color: #bebebe;
}

.bill-center-top {
  top: 50px;
  position: relative;
}

.bill-center-bg {
  background: white;
}

.bill-center-row {
  height: 50px;
  position: relative;
}

.bill-center-row input {
  font-size: 14px;
  color: black;
  margin-right: 13px;
}

.bill-center-txt {
  font-size: 15px;
  color: #323232;
  font-weight: bold;
  line-height: 50px;
  margin-left: 13px;
}

.bill-center-txt2 {
  font-size: 14px;
  color: #333333;
  line-height: 50px;
  margin-left: 13px;
}

.bill-radio-txt {
  height: 50px;
  font-size: 14px;
  color: #333333;
  margin-left: 13px;
  line-height: 50px;
}

.bill-center-txt2-width {
  width: 110px;
}

.bill-center-address-layout {
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
}

.bill-center-address-list-layout {
  height: 156px;
  width: 100%;
  padding-left: 13px;
  padding-right: 13px;
  overflow: auto;
  margin-bottom: 15px;
}

.bill-center-address-item {
  position: relative;
  width: 190px;
  height: 156px;
  margin-right: 10px;
  float: left;
  background: #f9f9f9;
}

.bill-center-address-item-unselect {
  border-width: 1px;
  border-color: #eeeeee;
  border-radius: 5px;
  border-style: solid;
}

.bill-center-address-item-select {
  border-width: 1px;
  border-color: #c41335;
  border-radius: 5px;
  border-style: solid;
}

.bill-center-address-item-title {
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  color: black;
  font-size: 12px;
  font-weight: bold;
}

.bill-center-address-item-txt {
  margin-left: 10px;
  color: black;
  font-size: 12px;
  margin-right: 10px;
}

.bill-center-address-item-txt1 {
  max-lines: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.bill-center-address-item-txt2 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.bill-center-address-item-edit-layout {
  height: 40px;
  padding-left: 5px;
  position: absolute;
  bottom: 0;
}

.bill-center-address-item-edit-layout span {
  margin-left: 5px;
  margin-right: 5px;
  color: #c41335;
  font-size: 12px;
}

.bill-center-address-item-default {
  position: absolute;
  right: 0;
  top: 0;
  background: #cccccc;
  border-style: none;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  width: 55px;
  height: 20px;
  color: white;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
}

.bill-center-address-item img {
  width: 13px;
  height: 13px;
  position: absolute;
  right: 0;
  bottom: 0;
}

.bill-center-address-add-layout {
  width: 105px;
  height: 35px;
  border-radius: 2px;
  border-style: solid;
  border-color: #fecdcd;
  border-width: 1px;
  color: #c41335;
  margin-left: 13px;
}

.bill-center-bottom-layout {
  position: fixed;
  bottom: 0;
  background: white;
  height: 65px;
  width: 100%;
  border-top-color: #f2f2f2;
  border-top-width: 1px;
  border-top-style: solid;
}

.bill-center-bottom-layout-none {
  display: none;
}

.bill-center-bottom-layout-block {
  display: block;
}

.bill-center-bottom-layout button {
  width: calc(100% - 13px * 2);
  height: 45px;
  position: relative;
  top: 10px;
  outline: none;
  color: white;
  font-size: 15px;
  border-radius: 4px;
  margin-left: 13px;
  margin-right: 13px;
}

.bill-center-row>>>.van-radio {
  display: inline-block;
}

.bill-center-row>>>.van-radio__icon {
  display: inline-block;
}

.bill-center-row>>>.van-radio__icon .van-icon {
  display: inline-block;
  vertical-align: top;
  margin-top: 1px;
}</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/billCenter.vue